<template>
    <div>
        <section-hero
            first
            section-name="jobs_hero"
            @scroll="$router.push({ hash: '#jobs' })"
        />
        <job-offer v-for="job in $store.state.jobs" :key="job.id" :job="job" />
        <section-references />
        <section-contact />
    </div>
</template>

<script>
import JobOffer from "@/components/JobOffer";
import SectionContact from "@/components/SectionContact";
import SectionHero from "@/components/SectionHero";
import SectionReferences from "@/components/SectionReferences";

export default {
    components: {
        JobOffer,
        SectionContact,
        SectionHero,
        SectionReferences,
    },
};
</script>
